import {
    Exercise,
    LabelBody,
    LabelDisplay2,
    SecondaryButton,
    Spacer,
} from '../../components';
import { ExerciseData, ExerciseViewProps } from '../../exercises';
import { ExerciseStatus } from '../../interfaces';

export const exerciseData33Completed: ExerciseData = {
    ExerciseView: Module3Exercise3Completed,
    dataKeys: [],
    questions: [],
};

function Module3Exercise3Completed({ onContinue }: ExerciseViewProps) {
    return (
        <Exercise title="" className="clouds">
            <Spacer />
            <LabelDisplay2 className="mb-10 text-center">
                Husk på!
            </LabelDisplay2>
            <LabelBody className="text-center">
                Det kan for mange være svært at få prioriteret selvomsorg, og
                det er det måske også for dig. Men det har du fortjent, lige så
                meget som alle andre.
            </LabelBody>
            <Spacer />
            <SecondaryButton
                className="mt-30"
                onClick={() =>
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: false,
                    })
                }
            >
                Tilbage til modulet
            </SecondaryButton>
        </Exercise>
    );
}
